import './landingPage.css';
import FreeTrialButton from '../../../../components/freeTrialButton/freeTrialButton';
import ImageContainer from '../../../../components/imageContainer/imageContainer';
import SpaceBar from '../../../../components/spacerBars/spaceBar';

export default function LandingPage({isMobile}) { 
   
    return(
        <div className="landing-page">
            <div className="landing-page-flex">
                <div className="landing-page-a">
                    <h1 className="">Take control of your business with <span>expensible</span></h1>
                    <SpaceBar width={isMobile ? '82%' : '42%'} offset={isMobile ? '4rem' : '10rem'}/>
                    <p className="landing-page-text-content">Cloud-based expense tracking, reporting, and forecasting that scales from one person to thousands.</p>
                </div>
                <div className="landing-page-b">
                    <ImageContainer type={false}/> 
                    {/*<div className="landing-image-container">
                        
                    </div>*/}
                    <div className="landing-page-call-to-action">
                        <FreeTrialButton/>
                    </div>
                </div>
            </div>
        </div>
    )
};